// Mapea errores técnicos a copy humano para mostrarlos en la UI. Nunca renderizar
// err.message directo — un mensaje sin mapear siempre cae al fallback provisto por
// el caller, en vez de mostrar jerga (stack traces, "Internal server error", inglés
// de HTTP/JS/DB) al usuario final.

const KNOWN_MESSAGES: Record<string, string> = {
  'Setup already complete': 'Este panel ya tiene una cuenta creada. Entra con esa cuenta en vez de configurar de nuevo.',
  'email and password required': 'Escribe un correo y una contraseña para continuar.',
  'tenantName and tenantSlug required': 'Escribe el nombre y el identificador de tu sitio para continuar.',
  'typeKeys required': 'Elige al menos un tipo de contenido para continuar.',
};

// Prefijos/formas que delatan un mensaje técnico (framework, HTTP, JS, stack trace)
// aunque no esté en el mapa anterior — nunca se muestran tal cual.
const TECHNICAL_PATTERN = /^(error|failed|internal|not found|network|typeerror|referenceerror|undefined|null)\b/i;
const STACK_TRACE_PATTERN = /\bat\s.+:\d+:\d+/;

export function toHumanMessage(err: unknown, fallback: string): string {
  const raw = err instanceof Error ? err.message : String(err ?? '');
  const trimmed = raw.trim();
  if (!trimmed) return fallback;
  if (trimmed in KNOWN_MESSAGES) return KNOWN_MESSAGES[trimmed];
  if (TECHNICAL_PATTERN.test(trimmed) || STACK_TRACE_PATTERN.test(trimmed)) return fallback;
  return trimmed;
}
